import { Flex, Loader } from '@components';
import { Container, StyledImage } from './InvestmentStructure.styles';
import { InvestmentStructure as InvestmentStructureTabContent } from '@features/api/response/tabContent/InvestmentStructure';
import { useTabData } from '@hooks/useTabData';
import { TabType } from '@features/api/response/tabContent/TabType';

const InvestmentStructure: React.FC = () => {
  const {
    data: investment,
    isFetching,
    isLoading,
  } = useTabData<InvestmentStructureTabContent>(TabType.INVESTMENTSTRUCTURE);

  if (!investment) return <Loader isLoading={isFetching || isLoading} />;
  if (!investment.blocks.length)
    return <Loader isLoading={isFetching || isLoading} />;

  const headerImages = investment.blocks.slice(0, 2);
  return (
    <Container>
      <Flex gap={3}>
        {headerImages?.map((x) => (
          <Flex width='50%'>
            <StyledImage
              alt={`sequential-block-image-${x.sequenceNumber}`}
              src={x.value}
              key={x.sequenceNumber}
            />
          </Flex>
        ))}
      </Flex>
      <Flex width='100%'>
        <StyledImage
          alt={`sequential-block-image-${investment.blocks[2].sequenceNumber}`}
          src={investment.blocks[2].value}
        />
      </Flex>
    </Container>
  );
};

export default InvestmentStructure;
